import React, { useEffect, useState } from "react";
import SolutionContentCard from "./SolutionContentCard";
import { getContentInfoBySubjectId } from "../services/SolutionDetailAPI";
import { Button } from "@chakra-ui/react";

const SolutionSubjectCard = (props) => {
    let [contentCards, setContentCards] = useState([]);
    let [contentList, setContentList] = useState([]);
    let [subjectName, setSubjectName] = useState();

    useEffect(() => {
        getContentInfoBySubjectId(props.subjectId).then((res) => {
            setContentList(res.contentList);
            setSubjectName(res.subject);
        });
    }, []);

    useEffect(() => {
        let cards = [];
        contentList.map((content) => {
            cards.push(
                <SolutionContentCard
                    key={content["contentID"]}
                    content={content["content"]}
                    id={content["contentID"]}
                    type={content["type"]}
                />
            );
        });
        setContentCards(cards);
    }, [contentList]);

    const handleOnClick = () => {
        window.location.href = `/business/subject-detail?id=${props.subjectId}`;
    };

    return (
        <div className="justify-center items-center my-10" style={{ width: "1300px" }}>
            <div
                style={{
                    fontSize: "large",
                    fontWeight: "bold",
                    borderBottom: "2px solid #4f71be",
                    marginBottom: "10px",
                }}
            >
                {subjectName}
                {props.moreInfoFlag?<Button
                        fontSize="xl"
                        size="md"
                        colorScheme="green"
                        ml={3}
                        mb={1}
                        onClick={() => handleOnClick()}
                    >
                        상세정보 더보기
                    </Button>:<></>}
            </div>

            {contentCards}
        </div>
    );
};
export default SolutionSubjectCard;
